import React, { useState } from 'react';
import Content from '../components/Content';
import { Box, Card, CardContent, CardHeader } from '@material-ui/core';
import FormReport from '../components/reports/FormReport';
import moment from 'moment';
import generateCsv from '../services/reports';

const ReportQuotes = ({
  userStore
}) => {

  const [loading, setLoading] = useState(false);

  const handleGenerateReport = async (values) => {
    setLoading(true);

    generateCsv(
      `${ process.env.REACT_APP_API_URL }reports/quotes`,
      userStore.token,
      values,
      () => setLoading(false),
      () => setLoading(false),
    );
  }

  return (
    <Content title="Relatório de trechos" userStore={userStore}>
      <Card>
        <Box>
          <CardHeader title="Período das criações dos trechos" />
          <CardContent>
            <FormReport
              users={userStore} 
              loading={loading} 
              onSubmit={(value) => {
                const data = {
                  ...value,
                  startDate: moment(value.startDate).format(),
                  endDate: moment(value.endDate).format() 
                };

                handleGenerateReport(data);
              }}
            />
          </CardContent>
        </Box>
      </Card>
    </Content>
  );
};

export default ReportQuotes;
